<template>
  <div>
    <el-card class="box-card">
      <!-- 上方操作栏 -->
      <el-form
        :model="formData"
        :inline="true"
        class="demo-form-inline"
        style="display: flex; justify-content: space-between; align-items: center;"
      >
        <el-form-item label="系列">
          <el-select
            v-model="formData.cate1_id"
            placeholder="请选择系列"
            @change="handleCate1Change"
            filterable
          >
            <el-option
              v-for="item in cate1List"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="refreshData">同步价格管理数据</el-button>
        </el-form-item>
      </el-form>

      <!-- 下方展示界面 -->
      <div class="score-display-container">
        <div v-if="loading" class="loading-container">
          <i class="el-icon-loading"></i>
          <span>正在加载数据...</span>
        </div>
        
        <div v-else-if="(categoryData || []).length === 0" class="empty-container">
          <el-empty description="暂无数据" />
        </div>
        
        <div v-else>
          <!-- 直接遍历二级分类 -->
          <div class="cate2-container">
            <el-card 
              v-for="cate2 in categoryData" 
              :key="cate2.id" 
              class="cate2-card"
            >
                <div class="cate2-header">
                  <h4 class="cate2-name">{{ cate2.name }}</h4>
                  <span class="score-count">{{ cate2.autoUpdateStatus.length }}个分值</span>
                </div>
                
                <!-- 遍历分值状态 -->
                <div class="score-grid">
                  <el-tag
                    v-for="score in cate2.autoUpdateStatus"
                    :key="score.id"
                    size="small"
                    :type="score.status === 1 ? 'success' : 'info'"
                    :effect="score.status === 1 ? 'normal' : 'plain'"
                    class="score-tag"
                    @click="toggleScoreStatus(score)"
                    :title="score.status ? '点击禁用该分值' : '点击启用该分值'"

                  >
                    {{ score.score.includes('sp') ? score.score : score.score + '分' }}
                  </el-tag>
                </div>
              </el-card>
            </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "AdminAutoUpdatePrice",
  data() {
    return {
      formData: {
        cate1_id: null
      },
      cate1List: [],
      categoryData: [],
      loading: false
    };
  },
  created() {
    this.getCate1List();
  },
  methods: {
    // 获取系列列表
    getCate1List() {
      request.get("/common/getCate1List", {}).then((res) => {
        this.cate1List = res.data;
      });
    },
    
    // 选择系列后自动获取该系列下的分值信息
    handleCate1Change(cate1Id) {
      if (cate1Id) {
        this.getScoreListByCate1(cate1Id);
      } else {
        this.categoryData = [];
      }
    },
    
    // 根据系列获取分值列表
    getScoreListByCate1(cate1Id) {
      this.loading = true;
      request
        .get("/admin/auto-update-price/cate-status", {
          params: {
            cate1_id: cate1Id
          }
        })
        .then((res) => {
          if (res.code === "0") {
              // 适配实际API响应格式，直接存储二级分类列表
              this.categoryData = res.data.cate2List || [];
          } else {
            this.$message({
              type: "error",
              message: res.msg || "获取数据失败"
            });
            this.categoryData = [];
          }
        })
        .catch((error) => {
          console.error("获取分值列表失败:", error);
          this.$message({
            type: "error",
            message: "获取数据失败"
          });
          this.categoryData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 切换分值状态
    toggleScoreStatus(score) {
      const newStatus = score.status === 0 ? 1 : 0;
      //this.loading = true;
      
      request
        .post("/admin/auto-update-price/updateScoreStatus", {
          cate2_id: score.cate2_id,
          score: score.score,
          status: newStatus
        })
        .then((res) => {
          if (res.code === "0") {
            // 更新本地数据状态
            score.status = newStatus;
            this.$message({
              type: "success",
              message: res.msg || "更新成功"
            });
          } else {
            this.$message({
              type: "error",
              message: res.msg || "更新失败"
            });
          }
        })
        .catch((error) => {
          console.error("更新分值状态失败:", error);
          this.$message({
            type: "error",
            message: "更新失败"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 同步数据
    refreshData() {
      this.loading = true;
      
      request
        .post("/admin/auto-update-price/sync-from-price")
        .then((res) => {
          if (res.code === "0") {
            this.$message({
              type: "success",
              message: res.msg || "同步成功"
            });
            // 同步成功后，重新加载当前系列的数据
            if (this.formData.cate1_id) {
              this.getScoreListByCate1(this.formData.cate1_id);
            }
          } else {
            this.$message({
              type: "error",
              message: res.msg || "同步失败"
            });
          }
        })
        .catch((error) => {
          console.error("同步数据失败:", error);
          this.$message({
            type: "error",
            message: "同步失败"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
/* 操作栏样式 */
.demo-form-inline {
  margin-bottom: 20px;
}

/* 展示容器样式 */
.score-display-container {
  min-height: 400px;
  padding: 10px 0;
}

/* 加载状态样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #606266;
}

.loading-container i {
  font-size: 32px;
  margin-bottom: 10px;
  color: #409eff;
  animation: el-rotate 1s linear infinite;
}

/* 空状态样式 */
.empty-container {
  padding: 60px 0;
}

/* 分值网格布局 */
.score-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

/* 分值标签样式 */
.score-tag {
  margin: 0px 0px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.score-tag:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 分类数量样式 */
.score-count {
  font-size: 13px;
  color: #909399;
}



/* 二级分类容器样式 */
.cate2-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

/* 二级分类卡片样式 */
.cate2-card {
  flex: 1;
  min-width: 300px;
  max-width: calc(50% - 8px);
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

/* 二级分类头部样式 */
.cate2-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #ebeef5;
}

.cate2-name {
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  color: #303133;
}


</style>